export default __webpack_public_path__ + "static/media/information.241e3962.svg";